/* eslint-disable */
import Oidc from "oidc-client";
import LogRocket from "logrocket";
import LoginReturn from "../../public/login-return.js";
import { buildLogoutUrl } from "./logoutUrl";

const authority = process.env.OIDC_AUTHORITY;
const client_id = process.env.OIDC_CLIENT_ID;
const base_url = process.env.OIDC_BASE_URI;
const response_type = "id_token token";
const scope = "openid profile groups";
// Must be listed in the Auth0 application's Allowed Logout URLs.
const logout_return_to = window.location.origin + "/";

var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore(),
  authority: authority,
  client_id: client_id,
  redirect_uri: window.location.origin + "/callback.html",
  response_type: response_type,
  scope: scope,
  silent_redirect_uri: window.location.origin + "/silent-renew.html",
  revokeAccessTokenOnSignout: false,
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true, 
  metadata: {
   authorization_endpoint: base_url + "/authorize",
  }
});

// First page that asked for a login in this page load (see signIn).
let loginReturnUrl = null;
// Set once a logout starts; a late login would replace the logout address in the tab.
let loggingOut = false;

// The store is saved in the tab's session storage (store.js) and survives the trip
// through Auth0, so the next person to sign in would start with these roles.
function forgetSavedState() {
  try {
    window.sessionStorage.clear();
  } catch (e) {
    // storage is blocked, so nothing was saved either
  }
}

// Auth0 publishes no end session endpoint, so signoutRedirect cannot end its
// session and Auth0 signs the user straight back in. Drop the local user, then
// let Auth0 end its session; it returns the browser to the site root.
function logout() {
  loggingOut = true;
  forgetSavedState();
  // a response that lands before the page goes would write the state back
  window.addEventListener("pagehide", forgetSavedState);
  const toAuth0 = function() {
    window.location.assign(
      buildLogoutUrl(base_url, client_id, logout_return_to)
    );
  };
  return mgr.removeUser().then(toAuth0, toAuth0);
}

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function(user) {
  //
 
});

mgr.events.addAccessTokenExpiring(function() {
  //
});

// An expired token is not a logout: Auth0 keeps its session, so the sign-in brings
// the user back to the same page without a password.
// A tab left idle keeps the timer of the user it first read, so check the stored
// user: another tab may have signed in again since.
mgr.events.addAccessTokenExpired(function() {
  const signInAgain = function() {
    new SecurityService().signIn();
  };
  mgr.getUser().then(function(user) {
    if (user && !user.expired) return;
    mgr.removeUser().then(signInAgain, signInAgain);
  });
});

mgr.events.addSilentRenewError(function() {
  console.error("Silent Renew Error：", arguments);
});

mgr.events.addUserSignedOut(function() {
  alert("Going out!");
  logout();
});

export default class SecurityService {
  // Renew the token manually
  renewToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent()
        .then(function(user) {
          if (user == null) {
            self.signIn(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Check if there is any user logged in
  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Redirect of the current window to the authorization endpoint. The page that
  // asked for it travels in the login state, so the callback can send the user back.
  // A login page or logout path is never kept, so nothing is stored for it.
  // Every call leaves the page, so the first page is the one the user asked for;
  // later calls (a route guard may have moved the tab) keep it.
  signIn() {
    if (loggingOut) return;
    loginReturnUrl =
      loginReturnUrl ||
      LoginReturn.target(
        {
          returnUrl:
            window.location.pathname +
            window.location.search +
            window.location.hash
        },
        null
      );
    const request = loginReturnUrl
      ? mgr.signinRedirect({ data: { returnUrl: loginReturnUrl } })
      : mgr.signinRedirect();
    request.catch(function(err) {
      loginReturnUrl = null; // the page stays, so the next attempt starts again
    });
  }

  // Sign out of the app and of Auth0
  signOut() {
    logout();
  }

  // Get the profile of the user logged in
  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
             LogRocket.identify("THE_USER_ID_IN_YOUR_APP", {
              name: user.profile.name,
              email: user.profile.email,
              environmente: process.env.ENVIRONMENT
            });
            return resolve(user);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAcessToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }

  // Get the user roles logged in
  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.groups);
          }
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }
}
